export const ourProducts = [
  {
    title: 'Smart Manufacturing Execution Systems (MES)', 
    subtitle:
      'Transform your manufacturing processes with Smart MES. This intelligent system integrates production data, optimizes workflows, and enhances decision-making for increased efficiency and quality in manufacturing operations.',
    img: 'url(/industries/manufacturing/smart-manufacturing-execution-systems.avif)',
    content:
      'Integrate production data, optimize workflows, and enhance decision-making for increased efficiency and quality in manufacturing operations with our Smart Manufacturing Execution Systems (MES).',
    link: '/industries/manufacturing/products/smart-manufacturing-execution-systems',
  },
  {
    title: 'Predictive Maintenance and Condition Monitoring Software',
    subtitle:
      'Ensure equipment reliability with Predictive Maintenance Software. By leveraging data analytics, this solution predicts potential failures, allowing proactive maintenance to reduce downtime and extend the lifespan of machinery.',
    img: 'url(/industries/manufacturing/predictive-maintenance-and-condition-monitoring-software.jpg)',
    content:
      'Predict potential failures, allowing proactive maintenance to reduce downtime and extend the lifespan of machinery with our Predictive Maintenance and Condition Monitoring Software.',
    link: '/industries/manufacturing/products/predictive-maintenance-and-condition-monitoring-software',
  },
  {
    title: 'Digital Twin Technology for Manufacturing Processes',
    subtitle:
      'Revolutionize manufacturing with Digital Twin Technology. Create virtual replicas of physical processes, enabling real-time monitoring, analysis, and optimization for improved efficiency and innovation.',
    img: 'url(/industries/manufacturing/digital-twin-technology-for-manufacturing-processes.avif)',
    content:
      'Create virtual replicas of physical processes, enabling real-time monitoring, analysis, and optimization for improved efficiency and innovation with our Digital Twin Technology for Manufacturing Processes.',
    link: '/industries/manufacturing/products/digital-twin-technology-for-manufacturing-processes',
  },
  {
    title: 'Advanced Robotics and Automation Control Systems',
    subtitle:
      'Embrace automation excellence with Advanced Robotics and Automation Control Systems. These cutting-edge solutions optimize robot movements, enhance precision, and streamline manufacturing processes for increased productivity.',
    img: 'url(/industries/manufacturing/advanced-robotics-and-automation-control-systems.avif)',
    content:
      'Optimize robot movements, enhance precision, and streamline manufacturing processes for increased productivity with our Advanced Robotics and Automation Control Systems.',
    link: '/industries/manufacturing/products/advanced-robotics-and-automation-control-systems',
  },
  {
    title: 'Additive Manufacturing (3D Printing) Software',
    subtitle:
      'Redefine manufacturing possibilities with Additive Manufacturing Software. This technology enables precise control over 3D printing processes, allowing the creation of complex components with efficiency and accuracy.',
    img: 'url(/industries/manufacturing/additive-manufacturing-3d-printing-software.avif)',
    content:
      'Enable precise control over 3D printing processes, allowing the creation of complex components with efficiency and accuracy with our Additive Manufacturing (3D Printing) Software.',
    link: '/industries/manufacturing/products/additive-manufacturing-3d-printing-software',
  },
  {
    title: 'Manufacturing Operations Management (MOM) Systems',
    subtitle:
      'Optimize end-to-end manufacturing processes with MOM Systems. These comprehensive solutions provide real-time visibility, control, and coordination of production activities for improved efficiency and responsiveness.',
    img: 'url(/industries/manufacturing/manufacturing-operations-management-systems.jpg)',
    content:
      'Provide real-time visibility, control, and coordination of production activities for improved efficiency and responsiveness with our Manufacturing Operations Management (MOM) Systems.',
    link: '/industries/manufacturing/products/manufacturing-operations-management-systems',
  },
  {
    title: 'Quality Management and Control Software',
    subtitle:
      'Elevate product quality with Quality Management and Control Software. This solution ensures adherence to quality standards, streamlines inspections, and enhances overall product integrity in the manufacturing process.',
    img: 'url(/industries/manufacturing/quality-management-and-control-software.avif)',
    content:
      'Ensure adherence to quality standards, streamline inspections, and enhance overall product integrity in the manufacturing process with our Quality Management and Control Software.',
    link: '/industries/manufacturing/products/quality-management-and-control-software',
  },
  {
    title: 'Supply Chain Digital Twins and Visibility Platforms',
    subtitle:
      'Enhance supply chain management with Digital Twins and Visibility Platforms. These solutions provide a holistic view of the supply chain, improving transparency, reducing risks, and optimizing logistics for efficient manufacturing operations.',
    img: 'url(/industries/manufacturing/supply-chain-digital-twins-and-visibility-platforms.avif)',
    content:
      'Provide a holistic view of the supply chain, improving transparency, reducing risks, and optimizing logistics for efficient manufacturing operations with our Supply Chain Digital Twins and Visibility Platforms.',
    link: '/industries/manufacturing/products/supply-chain-digital-twins-and-visibility-platforms',
  },
  {
    title: 'Enterprise Resource Planning (ERP) for Manufacturing',
    subtitle:
      'Streamline business processes with ERP tailored for manufacturing. This solution integrates planning, production, and inventory management, enabling efficient resource allocation, cost control, and improved decision-making.',
    img: 'url(/industries/manufacturing/erp-for-manufacturing.avif)',
    content:
      'Integrate planning, production, and inventory management, enabling efficient resource allocation, cost control, and improved decision-making with our Enterprise Resource Planning (ERP) for Manufacturing.',
    link: '/industries/manufacturing/products/erp-for-manufacturing',
  },
  {
    title: 'Product Lifecycle Management (PLM) Systems',
    subtitle:
      'Manage the entire product lifecycle with PLM Systems. These solutions facilitate collaboration, data management, and version control, ensuring seamless product development from concept to end-of-life.',
    img: 'url(/industries/manufacturing/product-lifecycle-management-systems.avif)',
    content:
      'Facilitate collaboration, data management, and version control, ensuring seamless product development from concept to end-of-life with our Product Lifecycle Management (PLM) Systems.',
    link: '/industries/manufacturing/products/product-lifecycle-management-systems',
  },
  {
    title: 'Computer-Aided Design (CAD) and Simulation Tools',
    subtitle:
      'Drive innovation in product design with CAD and Simulation Tools. These applications empower engineers to create and simulate designs, ensuring accuracy, efficiency, and optimal performance.',
    img: 'url(/industries/manufacturing/cad-and-simulation-tools.avif)',
    content:
      'Empower engineers to create and simulate designs, ensuring accuracy, efficiency, and optimal performance with our Computer-Aided Design (CAD) and Simulation Tools.',
    link: '/industries/manufacturing/products/cad-and-simulation-tools',
  },
  {
    title: 'Collaborative Robot (Cobot) Programming Software',
    subtitle:
      'Facilitate human-robot collaboration with Cobot Programming Software. This intuitive solution simplifies the programming of collaborative robots, enhancing flexibility and efficiency on the manufacturing floor.',
    img: 'url(/industries/manufacturing/cobot-programming-software.avif)',
    content:
      'Simplify the programming of collaborative robots, enhancing flexibility and efficiency on the manufacturing floor with our Collaborative Robot (Cobot) Programming Software.',
    link: '/industries/manufacturing/products/cobot-programming-software',
  },
  {
    title: 'Inventory Optimization and Warehouse Management Systems',
    subtitle:
      'Optimize inventory management with Inventory Optimization and Warehouse Management Systems. These solutions streamline stock levels, reduce carrying costs, and improve overall warehouse efficiency.',
    img: 'url(/industries/manufacturing/inventory-optimization-and-warehouse-management-systems.jpg)',
    content:
      'Streamline stock levels, reduce carrying costs, and improve overall warehouse efficiency with our Inventory Optimization and Warehouse Management Systems.',
    link: '/industries/manufacturing/products/inventory-optimization-and-warehouse-management-systems',
  },
  {
    title: 'Industrial Internet of Things (IIoT) Platforms',
    subtitle:
      'Harness the power of data with IIoT Platforms. Connect devices, collect real-time data, and gain actionable insights to optimize processes, reduce downtime, and enhance overall manufacturing efficiency.',
    img: 'url(/industries/manufacturing/industrial-internet-of-things-platforms.avif)',
    content:
      'Connect devices, collect real-time data, and gain actionable insights to optimize processes, reduce downtime, and enhance overall manufacturing efficiency with our Industrial Internet of Things (IIoT) Platforms.',
    link: '/industries/manufacturing/products/industrial-internet-of-things-platforms',
  },
  {
    title: 'Factory Floor Data Collection and Analysis Software',
    subtitle:
      'Improve decision-making on the factory floor with Data Collection and Analysis Software. This solution gathers real-time production data, enabling analysis for continuous improvement in manufacturing processes.',
    img: 'url(/industries/manufacturing/factory-floor-data-collection-and-analysis-software.jpg)',
    content:
      'Gather real-time production data, enabling analysis for continuous improvement in manufacturing processes with our Factory Floor Data Collection and Analysis Software.',
    link: '/industries/manufacturing/products/factory-floor-data-collection-and-analysis-software',
  },
  {
    title: 'Energy Efficiency Monitoring in Manufacturing',
    subtitle:
      'Foster sustainability with Energy Efficiency Monitoring. This solution tracks energy consumption in manufacturing processes, identifying opportunities for efficiency improvements and reducing environmental impact.',
    img: 'url(/industries/manufacturing/energy-efficiency-monitoring-in-manufacturing.jpg)',
    content:
      'Track energy consumption in manufacturing processes, identify opportunities for efficiency improvements, and reduce environmental impact with our Energy Efficiency Monitoring in Manufacturing.',
    link: '/industries/manufacturing/products/energy-efficiency-monitoring-in-manufacturing',
  },
  {
    title: 'Smart Tooling and Equipment Maintenance Software',
    subtitle:
      'Ensure optimal equipment performance with Smart Tooling and Equipment Maintenance Software. This solution schedules preventive maintenance, tracks tool usage, and reduces unplanned downtime for increased productivity.',
    img: 'url(/industries/manufacturing/smart-tooling-and-equipment-maintenance-software.jpg)',
    content:
      'Schedule preventive maintenance, track tool usage, and reduce unplanned downtime for increased productivity with our Smart Tooling and Equipment Maintenance Software.',
    link: '/industries/manufacturing/products/smart-tooling-and-equipment-maintenance-software',
  },
  {
    title: 'Supplier Relationship Management (SRM) Systems',
    subtitle:
      'Strengthen partnerships with suppliers using SRM Systems. These solutions streamline communication, manage relationships, and optimize collaboration for a more resilient and efficient supply chain.',
    img: 'url(/industries/manufacturing/supplier-relationship-management-systems.jpg)',
    content:
      'Streamline communication, manage relationships, and optimize collaboration for a more resilient and efficient supply chain with our Supplier Relationship Management (SRM) Systems.',
    link: '/industries/manufacturing/products/supplier-relationship-management-systems',
  },
  {
    title: 'Materials Requirement Planning (MRP) Software',
    subtitle:
      'Optimize material flow with MRP Software. This solution ensures timely procurement, reduces excess inventory, and improves production planning for efficient manufacturing operations.',
    img: 'url(/industries/manufacturing/materials-requirement-planning-software.jpg)',
    content:
      'Ensure timely procurement, reduce excess inventory, and improve production planning for efficient manufacturing operations with our Materials Requirement Planning (MRP) Software.',
    link: '/industries/manufacturing/products/materials-requirement-planning-software',
  },
  {
    title: 'Augmented Reality for Maintenance and Training in Manufacturing',
    subtitle:
      'Embrace immersive experiences with Augmented Reality. This technology enhances maintenance and training by providing real-time guidance, improving troubleshooting, and enhancing skills development on the manufacturing floor.',
    img: 'url(/industries/manufacturing/augmented-reality-for-maintenance-and-training.jpg)',
    content:
      'Enhance maintenance and training by providing real-time guidance, improving troubleshooting, and enhancing skills development on the manufacturing floor with our Augmented Reality for Maintenance and Training.',
    link: '/industries/manufacturing/products/augmented-reality-for-maintenance-and-training',
  },
]

